{
  "loanDetail": {
    "loading": "Loading loan details...",
    "header": {
      "loan": "Loan",
      "loanType": "Loan Type:",
      "servicer": "Servicer:"
    },
    "loanInfo": {
      "title": "Loan Info",
      "loanId": "Loan ID:",
      "borrowerName": "Borrower Name:",
      "lastUpdate": "Last Update:",
      "generalDetails": "General Loan Details",
      "propertyDetails": "Property Details",
      "borrowerDetails": "Borrower Details"
    },
    "orders": {
      "title": "Orders",
      "search": "Search",
      "filter": "Filter",
      "clearAll": "Clear all",
      "filters": {
        "vendor": "Vendor",
        "status": "Status",
        "type": "Type",
        "slaStatus": "Client SLA Status"
      },
      "columns": {
        "orderId": "Order ID",
        "vendor": "Vendor",
        "orderStatus": "Order Status",
        "orderType": "Order Type",
        "createDate": "Create Date",
        "dueDate": "Client Due Date",
        "slaStatus": "Client SLA Status"
      },
      "emptyState": {
        "title": "No orders found.",
        "descriptionWithFilters": "Try adjusting your filters or search criteria.",
        "descriptionNoData": "There are no orders to display for this loan."
      }
    },
    "documents": {
      "title": "Documents",
      "search": "Search documents",
      "filter": "Filter",
      "clearAll": "Clear all",
      "filters": {
        "documentType": "Document Type",
        "source": "Source",
        "uploadedBy": "Uploaded By"
      },
      "columns": {
        "fileName": "File Name",
        "documentNumber": "Document #",
        "type": "Type",
        "source": "Source",
        "uploadedBy": "Uploaded by",
        "uploadDate": "Upload Date",
        "lastUpdate": "Last Update"
      },
      "emptyState": {
        "title": "No documents found.",
        "descriptionWithFilters": "Try adjusting your filters or search criteria.",
        "descriptionNoData": "There are no documents to display for this loan."
      }
    }
  }
}
